import React from 'react'

import styles from './Sidebar.module.scss'
import HFLogo from 'Images/hf_logo.svg'

const Product = () => {
  return (
    <div className={styles.ProductContainer}>
      <a href='https://happyfox.com' title='HappyFox' target='_blank' className={styles.ProductLogo} rel='noreferrer'>
        <HFLogo />
      </a>
    </div>
  )
}

export default Product
